export const canAccess = (user, key) => {
  if (!user) return false;
  if (user.role === "superadmin") return true;
  return user?.rights?.[key] === true;
};
